import type { HTMLAttributes, FC, Ref } from "react";
import { mergeClasses } from "@huub-web/utils";

import { Flex } from "../Flex/Flex";
import { Text } from "../Text/Text";
import {
  fieldSetStyle,
  headerStyle,
  inputsContainerStyle,
} from "./FieldSet.css";

export type FieldSetProps = HTMLAttributes<HTMLFieldSetElement> & {
  title?: string;
  description?: string;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLFieldSetElement>;
};

export const FieldSet: FC<FieldSetProps> = ({
  title,
  description,
  children,
  className,
  ref,
  ...props
}) => (
  <Flex
    ref={ref}
    as="fieldset"
    direction="column"
    gap="s"
    hideWhenEmpty
    data-template-key="fieldSet"
    className={mergeClasses(fieldSetStyle, className)}
    {...props}
  >
    {(!!title || !!description) && (
      <Flex gap="xxs" direction="column" className={headerStyle}>
        {title && (
          <Text variant="bodyL" as="h3" bold>
            {title}
          </Text>
        )}

        {description && (
          <Text
            variant="bodyS"
            as="p"
            color="currentColor50"
            style={{ maxWidth: "75%" }}
          >
            {description}
          </Text>
        )}
      </Flex>
    )}
    <Flex direction="column" gap="xs" className={inputsContainerStyle}>
      {children}
    </Flex>
  </Flex>
);
